/* Footer (sections/c-footer.liquid): the Chakra swastik (forms once; the glint after it is CSS in assets/c-footer.css since 21 October 2026; the wood fire was removed on 20 October 2026). The social icons are still (no script, 20 October 2026, night).
   Reduced motion: the finished swastik. The Mahadev film and its loader were removed on 15 October 2026 (Ivan). */
/* the shared 30 fps clock (the same lines as in assets/c-art.js, which explains it; whichever file loads first makes it) */
window.__c30 = window.__c30 || (function () {
  var subs = [], raf = 0, tmo = 0, last = 0, STEP = 30;
  function frame(now) {
    raf = 0; if (!subs.length) return;
    if (last && now - last < STEP) { raf = requestAnimationFrame(frame); return; }
    last = now; subs.slice().forEach(function (f) { f(now); }); arm();
  }
  function arm() {
    if (!subs.length || raf || tmo) return;
    var w = last ? last + STEP - 10 - performance.now() : 0;
    if (w > 1) tmo = setTimeout(function () { tmo = 0; if (subs.length && !raf) raf = requestAnimationFrame(frame); }, w);
    else raf = requestAnimationFrame(frame);
  }
  return {
    add: function (f) { if (subs.indexOf(f) < 0) subs.push(f); arm(); },
    remove: function (f) { var i = subs.indexOf(f); if (i >= 0) subs.splice(i, 1); if (!subs.length) { cancelAnimationFrame(raf); clearTimeout(tmo); raf = tmo = 0; } }
  };
})();
(function () {
  var calm = matchMedia('(prefers-reduced-motion: reduce)').matches, IOk = 'IntersectionObserver' in window;

  /* ---------- the swastik (Chakra), from webinar-lab/sw-chakra.html ---------- */
  function chakra(pan) {
    if (calm) return;
    var Q = function (s) { return pan.querySelector(s); }, svg = function (s) { return pan.querySelector(s); };
    var rot = Q('.c-rot'), fm = Q('.c-fm'), ol = Q('.c-ol'), heat = Q('.c-heat'), w1 = svg('.c-w1'), w2 = svg('.c-w2'), w3 = svg('.c-w3'),
        ring = Q('.c-ring'), rr = Q('.c-rr'), rd = Q('.c-rd'), rw = Q('.c-rw'), rh = Q('.c-rh'),
        moon = Q('.c-moon'), mr = Q('.c-mr'), bl = Q('.c-bl'), halo = Q('.c-halo');
    var END = 3.1, R0 = 110, raf = 0, t0 = 0, lt = 0, stopT = 0, N = 72;
    function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = cl(x); return x * x * (3 - 2 * x); }
    function oc(x) { x = cl(x); return 1 - Math.pow(1 - x, 3); }
    /* the theme's own easing, cubic-bezier(.65,0,.25,1) */
    function cb(x) { x = cl(x); var lo = 0, hi = 1, u = x; for (var i = 0; i < 18; i++) { u = (lo + hi) / 2; var bx = 3 * u * (1 - u) * (1 - u) * .65 + 3 * u * u * (1 - u) * .25 + u * u * u; if (bx < x) lo = u; else hi = u; } return 3 * u * u * (1 - u) + u * u * u; }
    function tf(a, s) { return 'translate(50 50) rotate(' + a.toFixed(2) + ') scale(' + s.toFixed(4) + ') translate(-50 -50)'; }
    /* written only when the value changes (18 October 2026), and the intro steps on the shared 30 fps clock (top of this file) */
    function op(el, v) { v = v.toFixed(3); if (el._op !== v) { el._op = v; el.style.opacity = v; } }
    function at(el, k, v) { var c = el._at || (el._at = {}); if (c[k] !== v) { c[k] = v; el.setAttribute(k, v); } }
    /* dasharray that shows only the dashes k (each 1.6 long, period 4 of 288) for which f(k) is true */
    function dash(f) { var a = [0], pos = 0;
      for (var k = 0; k < N; k++) if (f(k)) { a.push((4 * k - pos).toFixed(2), 1.6); pos = 4 * k + 1.6; }
      a.push((576 - pos).toFixed(2)); return a.join(' '); }
    function wedge(f) { if (f <= 0) return 'M0 0Z'; if (f >= 360) return 'M-12-12H112V112H-12Z';
      var r = f * Math.PI / 180, x = 50 + 90 * Math.sin(r), y = 50 - 90 * Math.cos(r);
      return 'M50 50V-40A90 90 0 ' + (f > 180 ? 1 : 0) + ' 1 ' + x.toFixed(2) + ' ' + y.toFixed(2) + 'Z'; }
    function render(t) {
      var o = sm(t / .55), a = -16 * Math.pow(1 - cl(t / 2.1), 3), s = .96 + .04 * oc(t / 1.5);
      at(rot, 'transform', tf(a, s));
      op(ol, .95 * o * (1 - sm((t - 1.1) / .65)));
      op(heat, .82 * sm((t - .4) / .5) * (1 - sm((t - 1.95) / .4)));
      /* moon threads the dashed orbit: one lap clockwise from the top, theme easing; the dashes drift the other way and rest */
      var H = 360 * cb((t - .12) / 1.8), R = R0 * (1 - oc(t / 2.3)), D = H - R + R0;
      at(rr, 'transform', 'rotate(' + R.toFixed(2) + ' 50 50)');
      at(mr, 'transform', 'rotate(' + H.toFixed(2) + ' 50 50)');
      /* molten gold follows the moon round the wheel (in the mark's own frame), feathered behind it */
      var F = H * 1.1 - 14 - a;
      at(w1, 'd', wedge(F - 16)); at(w2, 'd', wedge(F - 6)); at(w3, 'd', wedge(F));
      function m(k) { return (k * 5 + 1 + R0) % 360; }
      at(rd, 'stroke-dasharray', D >= 360 ? '1.6 2.4' : dash(function (k) { return m(k) < D; }));
      var tr = 1 - sm((t - 1.75) / .45);
      function bh(k) { return m(k) < D ? ((H - (k * 5 + 1) - R) % 360 + 720) % 360 : 999; }
      at(rw, 'stroke-dasharray', dash(function (k) { return bh(k) < 46; })); op(rw, .55 * tr);
      at(rh, 'stroke-dasharray', dash(function (k) { return bh(k) < 16; })); op(rh, .9 * tr);
      op(ring, .9 * sm((t - .08) / .2) * (1 - sm((t - 2.25) / .75)));
      op(moon, sm((t - .08) / .25) * (1 - sm((t - 1.95) / .45)));
      var b = sm((t - 1.82) / .4) * (1 - sm((t - 2.3) / .75)); op(bl, .85 * b); op(halo, .4 * b);
    }
    function finish() {
      raf = 0; rot.removeAttribute('transform'); rot._at = null; fm.removeAttribute('mask');
      [ol, heat, ring, moon, bl, halo].forEach(function (e) { e.style.opacity = ''; e._op = null; });
      stopT = setTimeout(function () { pan.classList.remove('pre', 'go'); pan.classList.add('gl'); pan.dispatchEvent(new CustomEvent('cft:done')); }, 500);
    }
    function tick(now) { if (now - lt < 30) return; lt = now; var t = (now - t0) / 1000; if (t >= END) { window.__c30.remove(tick); render(END); finish(); return; } render(t); }
    function prep() { window.__c30.remove(tick); raf = 0; clearTimeout(stopT); pan.classList.remove('gl'); fm.setAttribute('mask', 'url(#cftMR)'); render(0); }
    function play() { pan.classList.remove('go'); pan.classList.add('pre'); void pan.offsetWidth; pan.classList.add('go'); prep(); t0 = performance.now(); lt = 0; raf = 1; window.__c30.add(tick); }
    pan.classList.add('pre'); prep(); 
    if ('IntersectionObserver' in window) {
      var io1 = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io1.disconnect(); play(); } }, { threshold: .8 }); io1.observe(pan);
      var vis = false, live = function () { pan.classList.toggle('live', vis && !document.hidden); };
      new IntersectionObserver(function (es) { vis = es[0].isIntersecting; live(); }).observe(pan);
      document.addEventListener('visibilitychange', live);
    } else { pan.classList.add('live'); play(); }
  }

  function init(root) {
    if (!root || root._cft) return; root._cft = 1;
    var sw = root.querySelector('.cft-sw'); if (sw) chakra(sw);
  }
  [].forEach.call(document.querySelectorAll('[data-cft]'), init);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-cft]'); if (r) init(r); });
})();
